import { render } from "./CampaignView.vue?vue&type=template&id=261ed3d8&scoped=true&ts=true&lang=html"
import script from "./CampaignView.vue?vue&type=script&lang=ts"
export * from "./CampaignView.vue?vue&type=script&lang=ts"

import "./CampaignView.vue?vue&type=style&index=0&id=261ed3d8&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-261ed3d8"]])

export default __exports__